var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.label || _vm.textHelper
        ? _c(
            "v-subheader",
            { staticClass: "mb-4" },
            [
              _vm._v(" " + _vm._s(_vm.label) + " "),
              _vm.textHelper
                ? _c("emc-info-help", {
                    attrs: {
                      "icon-color": "indigo",
                      title: "Informações",
                      text: _vm.textHelper,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("v-slider", {
        attrs: {
          max: _vm.max,
          min: _vm.min,
          "thumb-size": 24,
          "thumb-label": _vm.thumbLabel,
          ticks: _vm.ticks,
          disabled: _vm.disabled,
          step: _vm.step,
          "hide-details": "",
          "append-icon": "mdi-plus-circle-outline",
          "prepend-icon": "mdi-minus-circle-outline",
        },
        on: { "click:append": _setup.sizeIn, "click:prepend": _setup.sizeOut },
        model: {
          value: _setup.size,
          callback: function ($$v) {
            _setup.size = $$v
          },
          expression: "size",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }